import { Action, createReducer, on } from "@ngrx/store";
import * as Actions from "./nav.actions";
import { INav } from "../../types/nav";

export const featureName = "nav";

const LINK_MENU = {
  NAV: [
    { text: "会社概要", link: "/company", innerLink: true, valid: true },
    { text: "企業理念", link: "/philosophy", innerLink: true, valid: true },
    { text: "事業概要", link: "/business", innerLink: true, valid: true },
    { text: "沿革", link: "/history", innerLink: true, valid: true },
    { text: "アクセス", link: "/access", innerLink: true, valid: true },
    // {
    //   text: 'お問い合わせ',
    //   link: 'https://pro.form-mailer.jp/fms/dda4888788864',
    //   innerLink: false,
    //   valid: true,
    // },
    {
      text: "採用情報",
      link: "https://pro.form-mailer.jp/lp/306ddcea187570",
      innerLink: false,
      valid: true,
    },
  ],
  // PLAY_BACK: [{ text: 'TOP', link: '/#play_back', innerLink: false }],
};

export const initialState: INav = {
  snav: false,
  links: LINK_MENU.NAV,
};

const _navReducer = createReducer(
  initialState,
  on(Actions.open, (state) => ({
    ...state,
    snav: true,
  })),
  on(Actions.close, (state) => ({
    ...state,
    snav: false,
  })),
  on(Actions.toggle, (state) => {
    const newState: INav = structuredClone(state);
    newState.snav = !state.snav;
    return newState;
  }),
);

export function navReducer(state: INav | undefined, action: Action) {
  return _navReducer(state, action);
}
